'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumberForm$() {
  this.aS7 = null;
  this.aSo = null;
  this.aSa = null;
  this.aSb = false;
  this.aSg = null;
  this.aSh = false;
  this.aSm = null;
  this.aSn = false;
  this.aS8 = null;
  this.aS9 = false;
  this.aSk = null;
  this.aSl = false;
  this.aSi = null;
  this.aSj = false;
  this.aSc = null;
  this.aSd = false;
  this.aSe = null;
  this.aSf = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumberForm$ = this;
  this.aS7 = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumber$();
  this.aSo = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($m_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumber$());
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumberForm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumberForm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumberForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumberForm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumberForm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumberForm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumberForm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumberForm$.prototype = $p;
$p.eR = (function() {
  return this.aS7;
});
$p.eO = (function() {
  return this.aSo;
});
$p.bW = (function() {
  if ((!this.aSb)) {
    this.aSa = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aSb = true;
  }
  return this.aSa;
});
$p.b9 = (function() {
  if ((!this.aSh)) {
    this.aSg = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aSh = true;
  }
  return this.aSg;
});
$p.b3 = (function() {
  if ((!this.aSn)) {
    this.aSm = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aSn = true;
  }
  return this.aSm;
});
$p.aG = (function() {
  if ((!this.aS9)) {
    this.aS8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aS9 = true;
  }
  return this.aS8;
});
$p.az = (function() {
  if ((!this.aSl)) {
    this.aSk = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aSl = true;
  }
  return this.aSk;
});
$p.aY = (function() {
  if ((!this.aSj)) {
    this.aSi = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aSj = true;
  }
  return this.aSi;
});
$p.Jl = (function() {
  if ((!this.aSd)) {
    this.aSc = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Truck Number";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aSd = true;
  }
  return this.aSc;
});
$p.bso = (function() {
  if ((!this.aSf)) {
    this.aSe = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().jx;
    this.aSf = true;
  }
  return this.aSe;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumberForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumberForm$, "app.data.data_point_types$package$TruckNumberForm$", ({
  GA: 1,
  N: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumberForm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumberForm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumberForm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumberForm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumberForm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumberForm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumberForm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumberForm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumberForm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumberForm$ };
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumber$() {
  this.aS5 = null;
  this.aS6 = false;
  this.aS3 = null;
  this.aS4 = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumber$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumber$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumber$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumber$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumber$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumber$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumber$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumber$.prototype = $p;
$p.aA = (function() {
  if ((!this.aS6)) {
    this.aS5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aS6 = true;
  }
  return this.aS5;
});
$p.bs6 = (function() {
  if ((!this.aS4)) {
    this.aS3 = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumberForm$().Jl();
    this.aS4 = true;
  }
  return this.aS3;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumber$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumber$, "app.data.data_point_types$package$TruckNumber$", ({
  Gz: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumber$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumber$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumber$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumber$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumber$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumber$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumber$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumber$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumber$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$TruckNumber$ };
//# sourceMappingURL=app.data.data_point_types$package$-Truck-Number$.js.map
